import { render, staticRenderFns } from "./PWAInstallButton.vue?vue&type=template&id=10e37031&scoped=true"
import script from "./PWAInstallButton.vue?vue&type=script&lang=ts"
export * from "./PWAInstallButton.vue?vue&type=script&lang=ts"
import style0 from "./PWAInstallButton.vue?vue&type=style&index=0&id=10e37031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e37031",
  null
  
)

export default component.exports